/**
 * Reads what an admin typed as an amount. Extra decimals are cut off, not
 * rounded, so `2.7559` in a JOD field becomes `2.755` and never `2.756`.
 *
 * Works on the text rather than on the number, because `Math.floor(1.005 * 100)`
 * is `100` (the product is `100.49999999999999`).
 */
export const parseAmountValue = (
  value: string,
  decimals = 2
): number | undefined => {
  const cleaned = value.replace(/[^\d.]/g, "");
  const [whole, ...rest] = cleaned.split(".");
  const fraction = rest.join("").slice(0, decimals);

  if (whole === "" && fraction === "") {
    return undefined;
  }

  const num = parseFloat(`${whole || "0"}${fraction ? `.${fraction}` : ""}`);

  return isNaN(num) ? undefined : num;
};

/** Allows typing digits and at most `decimals` places after one dot. */
export const amountPattern = (decimals: number) =>
  new RegExp(`^\\d*(\\.\\d{0,${decimals}})?$`);
